module.exports = __webpack_public_path__ + "img/marker4.c1017c43.webp";